import React from 'react';
import {FormField, FormSection, FormActions} from '../../../Presentation/components/common';
import {useFormState, CommonValidationRules, createFieldProps} from '../../../Presentation/utils/formUtils';

interface TagFormProps {
  initialName?: string;
  onSubmit: (name: string) => void;
  onCancel: () => void;
  submitting?: boolean;
}

const TagForm: React.FC<TagFormProps> = ({initialName = '', onSubmit, onCancel, submitting}) => {
  // Centralized form state
  const [formState, formActions] = useFormState(
    {
      name: initialName
    },
    {
      name: CommonValidationRules.required('اسم الوسم')
    }
  );

  const handleSubmit = async (data: { name: string }) => {
    onSubmit(data.name.trim());
  };

  return (
    <FormSection title="إضافة وسم جديد" description="أدخل اسم الوسم الجديد">
      <form onSubmit={(e) => { e.preventDefault(); formActions.submit(handleSubmit); }} className="space-y-6">
        <FormField
          type="text"
          label="اسم الوسم *"
          placeholder="أدخل اسم الوسم"
          {...createFieldProps('name', formState, formActions)}
          disabled={submitting}
          autoFocus
        />

        <FormActions
          onSubmit={() => formActions.submit(handleSubmit)}
          onCancel={onCancel}
          submitLabel="حفظ"
          cancelLabel="إلغاء"
          isLoading={formState.isSubmitting || submitting}
          disabled={!formState.isValid}
        />
      </form>
    </FormSection>
  );
};

export default TagForm;
